import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "./Spinner";
import { URL_LIST_ALL } from "../configs/api";

export default function UploadFileButton(props) {
    const { onSellect, onlytype, multiple, filename, type } = props;
    const { user } = useSelector((state) => state.auth);
    const fileUpload = useRef(null);
    const [uploading, setUploading] = useState(false);

    // Mở hộp chọn file
    const handleUpload = () => {
        if (!uploading) fileUpload.current.click();
    };

    // Upload file
    const uploadProfilePic = async (e) => {
        const fileloads = e.target.files;
        if (!fileloads || fileloads.length === 0) return;
        setUploading(true);

        try {
            const uploadPromises = Array.from(fileloads).map((fileload, index) => {
                let file_name = filename ? filename.replace("/", ".") : fileload.name;
                if (onlytype && index >= 1) {
                    file_name = file_name.replace(onlytype, "_" + index + onlytype);
                }

                const formData = new FormData();
                formData.append("file", fileload, file_name);
                formData.append("type", type);
                formData.append("name", "file");
                formData.append("filename", file_name);
                formData.append("changename", filename ? 0 : 1);
                formData.append("folder", 0);

                return Axios.post(URL_LIST_ALL + "fileupload", formData, user.config)
                    .then((res) => {
                        if (res.data.status === "success") {
                            return res.data.message;
                        } else {
                            confirmAlert({
                                title: "Lỗi upload",
                                message: res.data.message,
                                buttons: [{ label: "OK" }],
                            });
                            return null;
                        }
                    })
                    .catch((err) => {
                        console.error("Upload error:", err);
                        return null;
                    });
            });

            const results = await Promise.all(uploadPromises);
            const uploadedFiles = results.filter(Boolean); // bỏ null

            if (onSellect) onSellect(uploadedFiles); // ✅ chỉ trả ra danh sách file sau khi upload xong
        } finally {
            setUploading(false);
            e.target.value = ""; // reset input để chọn lại được cùng file
        }
    };

    return (
        <div className="col-6 col-sm-4 mb-3">
            <div className="upload-modal d-flex align-items-center">
                <input
                    type="file"
                    ref={fileUpload}
                    className="d-none"
                    onChange={uploadProfilePic}
                    accept={onlytype ? onlytype : "*"}
                    multiple={multiple || false}
                />
                <button
                    className="w-100 btn-upload btn btn-sm btn-info text-white"
                    type="button"
                    onClick={handleUpload}
                    disabled={uploading}
                >
                    <span className="fas fa-cloud-upload-alt mr-3"></span>
                    {uploading ? <>Đang tải lên...<Spinner /></> : "Tải file lên"}
                </button>
            </div>
        </div>
    );
}
